import React, { useContext } from "react";
import MetricCard from "../../component/cards/metricCard";
import { Text } from "rizzui";
import cn from "../../lib/utils/class-name";
import IncreaseVector from "../../assets/increaseVector";
import DecreaseVector from "../../assets/decreaseVector";
import { ThemeContext } from "../../context/themeContext";
import UseFetchData from "../../hooks/useFetchData";
import useFetchData from "../../hooks/useFetchData";

const MetricText = ({ value }) => (
  <Text className="font-switzer font-[500] text-[24px] leading-[31.68px] text-primary-dark mt-[16px]">
    {value}
  </Text>
);

export default function StatCards({
  className,
  empty,
}: {
  className?: string;
  empty?: boolean;
}) {
  const { theme } = useContext(ThemeContext);
  const {
    data: leadsSummary,
    error: leadsError,
    isLoading: leadLoading,
  } = useFetchData({ dataType: "get_leads_summary" });

  const {
    data: callStats,
    error: callError,
    isLoading: callLoading,
  } = useFetchData({ dataType: "get_call_stats" });

  const DashboardStatData = [
    {
      id: "lead",
      title: "Leads",
      metric: <MetricText value={leadsSummary?.data?.last30DaysCount} />,
      increased:
        leadsSummary?.data?.last30DaysCount >
        leadsSummary?.data?.prev30DaysCount,
      percentage:
        Math.ceil(
          parseInt(leadsSummary?.data?.percentageChange?.replace("%", ""))
        ) + "%",
      isLoading: leadLoading,
      isZero: leadsSummary?.data?.last30DaysCount
        ? leadsSummary?.data?.last30DaysCount === 0
        : true,
    },
    {
      id: "2",
      title: "Total calls made",
      isZero: callStats?.data[0]?.totalCalls
        ? callStats?.data[0]?.totalCalls === 0
        : true,
      metric: <MetricText value={callStats?.data[0]?.totalCalls ?? 0} />,
      increased: true,
      percentage: "",
      isLoading: callLoading,
    },
    {
      id: "3",
      title: "Total call mins",
      metric: (
        <Text className="font-switzer font-[500] text-[24px] leading-[31.68px] text-primary-dark mt-[16px]">
          {callStats?.data[0]?.totalCallMinutes
            ? Math.ceil(callStats.data[0].totalCallMinutes / 60)
            : 0}{" "}
          <span className="font-[400] text-[14px] leading-[18.48px]">mins</span>
        </Text>
      ),
      increased: true,
      percentage: "",
      isLoading: callLoading,
      isZero: callStats?.data[0]?.totalCallMinutes
        ? callStats?.data[0]?.totalCallMinutes === 0
        : true,
    },
    {
      id: "4",
      title: "Avg call mins",
      metric: (
        <Text className="font-switzer font-[500] text-[24px] leading-[31.68px] text-primary-dark mt-[16px]">
          {callStats?.data[0]?.avgCallMinutes
            ? Math.ceil(callStats.data[0].avgCallMinutes / 60)
            : 0}{" "}
          <span className="font-[400] text-[14px] leading-[18.48px]">mins</span>
        </Text>
      ),
      increased: false,
      percentage: "",
      isLoading: callLoading,
      isZero: callStats?.data[0]?.avgCallMinutes
        ? callStats?.data[0]?.avgCallMinutes === 0
        : true,
    },
  ];
  return (
    <div className={cn("grid gap-[22px] 3xl:gap-8 4xl:gap-9", className)}>
      {DashboardStatData.map((stat) => (
        <MetricCard
          key={stat.title + stat.id}
          title={stat.title}
          isLoading={stat.isLoading}
          titleClassName="font-switzer font-[400] text-[14px] leading-[18.48px] text-[#758599]"
          metric={stat.metric}
          metricClassName="text-white dark:text-white"
          className="@container [&>div]:items-center rounded-[8px] border-[.5px] border-muted p-[16px] pr-0 pb-[4px] dark:bg-[#2A2C30] min-h-[130px]"
        >
          <div className="flex flex-row justify-between mt-[-10px]">
            {!stat.isZero && (
              <Text
                className={cn(
                  "font-switzer font-[400] text-[14px] leading-[18.48px] text-[#758599] mt-[14px]",
                  stat.increased ? "text-[#25A170]" : "text-[#E63946]"
                )}
              >
                {stat.increased ? `${stat.percentage}` : `${stat.percentage}`}
              </Text>
            )}
            {!stat.isZero &&
              (stat.increased ? (
                <IncreaseVector
                  color={theme === "dark" ? "#2A2C30" : "white"}
                />
              ) : (
                <DecreaseVector
                  color={theme === "dark" ? "#2A2C30" : "white"}
                />
              ))}
            {stat.isZero && (
              <div className="w-full px-[30px] mt-[30px]">
                <div className="w-[114px] border border-[#758599] h-[1px] float-right" />
              </div>
            )}
          </div>
        </MetricCard>
      ))}
    </div>
  );
}
